import React from 'react';
import { Link, Stack, TableBody, TableCell, TableRow } from '@mui/material';
import { TableCustom } from '../../../../../components/common';
import ApprovalSelect from './ApprovalSelect';
import formatDate from '../../../../../components/common/formatDate';
import {
  DeleteIconButton,
  EditIconButton,
  ViewIconButton,
} from '../../../../../components/common/button/CustomIconButton';
import { useNavigate } from 'react-router-dom';
import { UpdateButton } from '../../../../../components/common/button/CustomButtons';
import { useAuth } from '../../../../../services/auth/AuthProvider';
import CustomUploadButton from '../../../../../components/common/button/CustomUploadButton';

interface IProps {
  deleteDocument: (id: string) => void;
  updateStatus: (id: string, documentIndex: number) => void;
  uploadImage: any;
  statusObj: {
    pending: number;
    accepted: number;
    rejected: number;
  };
  tableData: {
    [key: string | number]: any;
  }[];
}
const getYearRange = (currentDate: any) => {
  if (!currentDate) return;
  const year = new Date(currentDate).getFullYear();
  return `${year} - ${year + 1}`;
};
const Header = [
  [
    {
      text: '#',
      colspan: 1,
      rowspan: 1,
    },

    {
      text: 'NAME',
      colspan: 1,
      rowspan: 1,
    },
    {
      text: 'Year',
      colspan: 1,
      rowspan: 1,
    },
    {
      text: 'UPLOAD FILE',
      colspan: 1,
      rowspan: 1,
    },
    {
      text: 'STATUS',
      colspan: 1,
      rowspan: 1,
    },
    {
      text: 'ACTION',
      colspan: 1,
      rowspan: 1,
    },
    {
      text: 'UPDATE STATUS',
      colspan: 1,
      rowspan: 1,
    },
  ],
];

const AdminTable = ({
  deleteDocument,
  updateStatus,
  uploadImage,
  statusObj,
  tableData,
}: IProps) => {
  const navigate = useNavigate();
  const { state } = useAuth();
  // const { user, IS } = state;
  return (
    <React.Fragment>
      <TableCustom tableHeaderObj={Header}>
        <TableBody>
          {tableData.map(
            (document: { [key: string]: any }, documentIndex: number) => (
              <TableRow key={documentIndex + 'admin'}>
                <TableCell align="center">{documentIndex + 1}</TableCell>
                <TableCell align="center">
                  {document.report_prepared_by}
                </TableCell>
                <TableCell align="center">
                  {getYearRange(document.createdAt)}
                </TableCell>

                <TableCell align="center">
                  <Stack justifyContent={'center'} direction={'row'}>
                    <CustomUploadButton
                      id={`${documentIndex}_files_`}
                      lable={'UPLOAD'}
                      accept="image/png,image/jpeg,image/jpg,application/pdf"
                      onChange={(e) =>
                        uploadImage(document._id, e.target.files)
                      }
                    />
                    {document.file && (
                      <Link target={'_blank'} href={document.file}>
                        <ViewIconButton tooltipTitle="view" />
                      </Link>
                    )}
                  </Stack>
                </TableCell>
                <TableCell align="center">
                  <ApprovalSelect
                    {...{
                      document,
                      documentIndex,
                      statusObj,
                    }}
                  />
                </TableCell>
                <TableCell align="center">
                  <ViewIconButton
                    tooltipTitle="view"
                    onClick={() =>
                      navigate(
                        `/common/qualityChecksheets/createLuxMonitoringReport?id=${document._id}&isView=true&partName=${document.part_id?.part_name}&partNumber=${document.part_id?.part_number}`,
                      )
                    }
                  />
                  <EditIconButton
                    tooltipTitle="edit"
                    onClick={() =>
                      navigate(
                        `/common/qualityChecksheets/createLuxMonitoringReport/${document._id}?id=${document._id}&isView=false&partName=${document.part_id?.part_name}&partNumber=${document.part_id?.part_number}`,
                      )
                    }
                  />
                  <DeleteIconButton
                    tooltipTitle="delete"
                    onClick={() => deleteDocument(document._id)}
                  />
                </TableCell>
                <TableCell align="center">
                  <UpdateButton
                    label="update"
                    size="small"
                    onClick={() => updateStatus(document._id, documentIndex)}
                  />
                </TableCell>
              </TableRow>
            ),
          )}
        </TableBody>
      </TableCustom>
    </React.Fragment>
  );
};

export default AdminTable;
